// User accounts (admin) and the self-service password change (every role).

import { api, type Schemas } from '@/api/client';
import { withSignal, type DictionaryApi } from '@/features/dictionaries/resources';
import { compact } from '@/lib/compact';

type S = Schemas;

/** A new account is created with a password, which is never returned: the table row
 * type carries it as an optional field so the create-only column can be typed. */
export type UserRow = S['UserOut'] & { password?: string };

export const usersApi: DictionaryApi<UserRow, S['UserCreate'], S['UserUpdate']> = {
  key: 'users',
  list: ({ q, is_active, limit, offset }, signal) =>
    api.get('/users', {
      query: compact({ q, is_active, limit, offset }),
      ...withSignal(signal),
    }),
  create: (body) => api.post('/users', { body }),
  update: (id, body) => api.patch('/users/{item_id}', { path: { item_id: id }, body }),
};

/** Admin sets a new password; every other session of that user ends. */
export function resetPassword(userId: number, password: string) {
  return api.post('/users/{user_id}/reset-password', {
    path: { user_id: userId },
    body: { password },
  });
}

export function changeOwnPassword(currentPassword: string, newPassword: string) {
  return api.post('/me/password', {
    body: { current_password: currentPassword, new_password: newPassword },
  });
}

/** Mirrors MIN_PASSWORD_LENGTH in backend/app/core/security.py. */
export const MIN_PASSWORD_LENGTH = 8;
